import { createSlice } from "@reduxjs/toolkit";
import { noCodeBuilderReducers } from "./reducer";

const initialState = {
  interval: "",
  strategy: [],
  assets: [],
  isLoading: false,
  errors: {},
  selectedAssets: [],
  assetGroups: [],
  isStrategyLoading: false,
};

export const noCodeBuilderSlice = createSlice({
  name: "noCodeBuilder",
  initialState,
  reducers: noCodeBuilderReducers,
});

export const {
  addThenAction,
  addElseAction,
  deleteThenActionAtIndex,
  deleteElseActionAtIndex,
  addStatement,
  deleteStatementAtIndex,
  addStrategy,
  deleteStrategyAtIndex,
  updateThenActionAtIndex,
  updateStatementAtIndex,
  updateSelectedTargetAssets,
  updateElseActionAtIndex,
  updateAll,
  updateInterval,
  clearNcbState,
  updateIsLoading,
  deleteAssetAtIndex,
  setErrors,
  addSelectedTargetAssets,
  addSelectedAssets,
  removeSelectedAssets,
  removeSelectedTargetAsset,
  addAssetGroups,
  removeAssetGroups,
  updateAssetGroups,
  addAssetInGroup,
  removeAssetInGroup,
  removeAssetInAllGroup,
  updateAssetGroupName,
  setIsStrategyLoading,
} = noCodeBuilderSlice.actions;

export default noCodeBuilderSlice.reducer;
